/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Incident_DetailInputs */



/**
* | output |
* | --- |
* | "Attendance and investigation following an incident or accident, on behalf of owners, charterers or managers. We gather evidence, establish the sequence of ev..." |
*
* @param {Service_Incident_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_incident_detail = /** @type {((inputs?: Service_Incident_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Incident_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在事件或事故发生后，代表船东、租家或管理公司到场调查。我们收集证据，厘清事件经过和促成因素，并提出调查结论，为保险人、法律顾问和日后的预防工作提供支持。")
	return /** @type {LocalizedString} */ ("Attendance and investigation following an incident or accident, on behalf of owners, charterers or managers. We gather evidence, establish the sequence of events and the contributing factors, and set out findings that support insurers, legal advisers and future prevention.")
});